export default __webpack_public_path__ + "static/healing_substance-82b033a9be4da46b678d15ac8971b771.png";